import axiosInstance from '../../../config/axiosInstance';
const PartService = {
    async GetAllParts(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllParts?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllNewParts(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, CustomerID = 0, SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Part/GetAllNewParts?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&CustomerID=${CustomerID}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPartCount(redirectCallback, searchQuery, SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetPartCount?ClientID=${ClientID}&searchQuery=${searchQuery}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPartByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetPartByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPartLocation(redirectCallback, StockID,Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {
            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Part/GetStockLocation?StockID=${StockID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async PartAlreadyExist(redirectCallback, StockCode) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/PartAlreadyExist?StockCode=${StockCode}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeletePart(redirectCallback, ID) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Part/DeletePart?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteStockLocation(redirectCallback, LocationID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeleteStockLocation?ID=${LocationID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async QuantityBreakDiscount(redirectCallback, StockID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/QuantityBreakDiscount?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async ShortFallParts() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/ShortFallParts?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async ShortFallPartsBySupplierID(SupplierID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/ShortFallPartsBySupplierID?ClientID=${ClientID}&SupplierID=${SupplierID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSerialTrackingByLocation(StockLocationID, SerialTracking = 0) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetSerialTrackingByLocation?ClientID=${ClientID}&StockLocationID=${StockLocationID}&SerialTracking=${SerialTracking}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdateTracking(formData) {
        try {

            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Part/UpdateTracking`, formData);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdateSerialNumbers(formData) {
        try {

            const CompanyID = localStorage.getItem("CompanyID");
            formData.formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.formData.UserID = UserID;
            const response = await axiosInstance.post(`/Part/UpdateSerialNumbers`, formData);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetStockSerialHistory(StockSerialID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetStockSerialHistory?ClientID=${ClientID}&StockSerialID=${StockSerialID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async IsSerialBatchAllocate(StockID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/IsSerialBatchAllocate?ClientID=${ClientID}&StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async SearchSerialTracking(StockLocationID, vc_Serial) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/SearchSerialTracking?StockLocationID=${StockLocationID}&vc_Serial=${vc_Serial}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async SerialTrackingFormat(StockID, Prefix = '') {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/SerialTrackingFormat?StockID=${StockID}&Prefix=${Prefix}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllNewSerialTracking(StockLocationID, SerialTracking = '0', Start, PageSize, searchQuery, sortColumn, sortDirection) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllNewSerialTracking?StockLocationID=${StockLocationID}&SerialTracking=${SerialTracking}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSerialTrackingCount(StockLocationID, SerialTracking = '0', searchQuery) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetSerialTrackingCount?StockLocationID=${StockLocationID}&SerialTracking=${SerialTracking}&searchQuery=${searchQuery}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetPartsByUser(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const ClientCompanyID = "0";
            const SupplierID = "0";
            const response = await axiosInstance.get(`/Part/GetPartsByUser?ClientID=${ClientID}&UserID=${UserID}&ClientCompanyID=${ClientCompanyID}&SupplierID=${SupplierID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockPart(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Part/LockPart?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockPart(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Part/UnLockPart?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SyncPartToFinancial(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/SyncCustomerToFinancialApp?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&action=Part`);
            if (response.data) {
                if (response.data.authUrl) {
                    // Open QuickBooks auth popup
                    const authPopup = window.open(
                        response.data.authUrl,
                        'QuickbookAuth',
                        'width=600,height=700,top=100,left=100'
                    );

                    if (!authPopup) {
                        throw new Error('Popup blocked. Please enable popups.');
                    }

                    // Polling to wait for user to close the popup
                    const interval = setInterval(() => {
                        if (authPopup.closed) {
                            clearInterval(interval);
                            console.log('Popup closed. Retrying QuickBooks customer creation...');
                            // Retry once popup is closed
                            //  this.QuickbookAddCustomer(ClientCompanyID);
                        }
                    }, 500);
                    return;
                } else {
                    // Success case
                    return response.data;
                }
            }

        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async InsertStockMovements(formData) {
        try {

            const CompanyID = localStorage.getItem("CompanyID");
            formData.ClientID = CompanyID;
            const UserID = localStorage.getItem("UserID");
            formData.UserID = UserID;
            const response = await axiosInstance.post(`/Part/InsertStockMovements`, formData);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async MoveParts(movePartsList, StockID, ToDepot) {
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            const payload = {
                ClientID: CompanyID,
                UserID: UserID,
                MovePartsList: movePartsList, // keep as array/object
                StockID,
                ToDepot
            };

            const response = await axiosInstance.post(`/Part/AddStockMovements`, payload);
            return response.data;
        } catch (error) {
            console.error("Error sending JSON:", error);
            throw error;
        }
    },
    async GetStockAndUserLocation(redirectCallback, StockID,Start, PageSize, searchQuery, sortColumn, sortDirection, SearchColumns) {
        try {
            Start = Start ?? 1;
            PageSize = PageSize ?? 1000;
            searchQuery = searchQuery ?? "";
            sortColumn = sortColumn ?? "ID";
            sortDirection = sortDirection ?? "DESC";
            SearchColumns = SearchColumns ?? "";
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Part/GetStockAndUserLocation?StockID=${StockID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default PartService;